module.exports = __webpack_public_path__ + "media/images/category_icons/song-b666fb78b224fd5120576d34c4a48cb3.svg";